import { defineMessages } from "react-intl";
const localizedDatePickerFooterSingleMode = defineMessages({
  datePickerFooterSingleModeDateLabel: {
    id: "datePickerFooterSingleModeDateLabel",
    defaultMessage: "Date"
  }
});
export {
  localizedDatePickerFooterSingleMode
};
//# sourceMappingURL=DatePickerFooterSingleMode.localize.js.map
